module.exports = __webpack_public_path__ + "img/1.ebe69e9c.jpg";